const ORDER_ITEM_LIST_STORAGE_KEY = "client_orderItemListTracking";
export class OrderItemListStorageManager {
    store(data) {
        const dataString = JSON.stringify(data);
        localStorage.setItem(ORDER_ITEM_LIST_STORAGE_KEY, dataString);
    }
    restore() {
        const dataString = localStorage.getItem(ORDER_ITEM_LIST_STORAGE_KEY);
        if (dataString === null) {
            return null;
        }
        return JSON.parse(dataString);
    }
    erase() {
        localStorage.removeItem(ORDER_ITEM_LIST_STORAGE_KEY);
    }
}
